export const CONNECT_DOMAIN = "connect.beanz.com";
export const BCC_DOMAIN = "bcc.beanz.com";

const getBcAndBccUrls = (): { bcUrl: string; bccUrl: string } | null => {
  const clientHost = process.env.REACT_APP_CLIENT_HOST?.replace(/\/$/, "");
  if (!clientHost) {
    return null;
  }

  if (clientHost.includes(CONNECT_DOMAIN)) {
    return {
      bcUrl: clientHost,
      bccUrl: clientHost.replace(CONNECT_DOMAIN, BCC_DOMAIN),
    };
  }

  if (clientHost.includes(BCC_DOMAIN)) {
    return {
      bcUrl: clientHost.replace(BCC_DOMAIN, CONNECT_DOMAIN),
      bccUrl: clientHost,
    };
  }

  return null;
};

export const isBccHost = (hostname: string): boolean => hostname.endsWith(BCC_DOMAIN);

export const isBcHost = (hostname: string): boolean => hostname.endsWith(CONNECT_DOMAIN);

export const getRedirectTarget = (isBccUser: boolean, hostname: string): string | null => {
  const urls = getBcAndBccUrls();
  if (!urls) {
    return null;
  }

  if (isBccUser && isBcHost(hostname)) {
    return urls.bccUrl;
  }

  if (!isBccUser && isBccHost(hostname)) {
    return urls.bcUrl;
  }

  return null;
};
